<template>
    <div>
         <p class="bigTitle"><span class="floor">*</span>订单管理>订单详情</p>
         <div class="body">
             <div class="steps">
                <el-steps :active="2" align-center class="stepsActive">
                    <el-step title="已提交订单" description="2020-03-10 10：03：27"></el-step>
                    <el-step title="待付款" description="2020-03-10 10：05：27"></el-step>
                    <el-step title="已付款" description="2020-03-10 10：07：27"></el-step>
                    <el-step title="已确定" description="2020-03-10 10：10：27"></el-step>
                    <el-step title="待入住" description="2020-03-10 10：15：27"></el-step>
                    <el-step title="已入住" description="2020-03-10 10：20：27"></el-step>
                    <el-step title="已离店" description="2020-03-10 10：39：27"></el-step>
                </el-steps>
             </div>


            
             <div class="Info">
                    <p class="infoTitle">
                        <span class="order">订单信息</span>
                        <span class="check">入住信息</span>
                    </p>
                 <div class="InfoBody">
                 <p>
                     <label>预订人:</label>
                     <span>张三</span>
                 </p>
                  <p>
                     <label>联系电话:</label>
                     <span>123456789</span>
                 </p>
                  <p>
                     <label>订单编号:</label>
                     <span>123456789</span>
                 </p>
                  <p>
                     <label>预定时间:</label>
                     <span>2020-03-10 10:03:27</span>
                 </p>
                  <p>
                     <label>房间信息:</label>
                     <span>特色双床房 1间</span>
                 </p>
                  <p>
                     <label>早餐:</label>
                     <span>含早</span>
                 </p>
                  <p>
                     <label>房费总额:</label>
                     <span>$260</span>
                 </p>
                 <p>
                     <label>付款方式:</label>
                     <span>微信支付</span>
                 </p>
                 <p>
                     <label>入住--离店:</label>
                     <span>2020/03/17--2020/03/18</span>
                 </p>


                 </div>

                 
             </div>
         </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        inputs: 226,
        //表格
        tableData: [{
          id: 2,
          date: '高级双床房',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        },{
          id: 3,
          date: '豪华大床房',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          children: [{
              id: 31,
              date: '豪华大床房-2份早餐-免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }, {
              id: 32,
              date: '豪华大床房-入住日18:00前可免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
          }]
        },{
          id: 4,
          date: '小单间',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        },{
          id: 5,
          date: '豪华大床房',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄',
          children: [{
              id: 31,
              date: '豪华大床房-2份早餐-免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
            }, {
              id: 32,
              date: '豪华大床房-入住日18:00前可免费取消',
              name: '王小虎',
              address: '上海市普陀区金沙江路 1519 弄'
          }]
        }],
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        value: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value1: '',
        value2: ''
      };
    },
    methods: {
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #409EFF;color: #fff'
      }
    }
  }
  };
</script>

<style scoped>

.infoTitle{
    padding-top: 1%;
}

.order{
    font-size: 20px;
    background-color: #D9EFFE;
    border:1px solid #000;
}

.check{
    font-size: 20px;
    border:1px solid #000;
}

.steps{
    background-color: #FFFFFF;
     border-radius: 5px;
}

.Info{
    background-color: #FFFFFF;
    border-radius: 5px;
    margin-top: 3%;
     margin-top: 2%;
}

.InfoBody{
    width: 80%;
    height: 400px;
    border:5px solid #D9EFFE;
    margin-left: 10%;
}

.stepsActive{
    padding-top: 1%;
    padding-bottom: 1%;
}

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    border-radius: 10px;
}

.batchButtom{
    margin-top: 1%;
    margin-right: 90%;
    margin-bottom: 1%;
}

.searchName{
    margin-left: 2%;
}

.searchButtom{
   margin-top: 1%;
   margin-right: 40%;
   margin-bottom: 1%;
}

.searchInput{
    width: 10%;
}

.saveButtom{
    margin-bottom: 1%;
}

.table{
    margin-left: 1%;
}

.thead{
    width: 100%;
}

.thOne{
    width: 10%;
    background-color: #409EFF;
}
.thName{
    width: 20%;
    color: #FFFFFF;
    background-color: #409EFF;
    height:50px;
}

.thDay{
    width: 160px;
    color: #FFFFFF;
    background-color: #409EFF;
    text-align: center;
}

.trTime{
    width: 160px;
    text-align: center;
}
.trDay{
    text-align: center;
}

.title{
    margin-left: 1%;
}

.tableInput{
    height: 30px;
    border-radius: 5px;
}
.optionInput{
    width: 15%;
}

.orderError{
    color: red;
}

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/order/orderInfo.vue